// extracted by mini-css-extract-plugin
export default {"gift-icon":"_1ehLE","giftIcon":"_1ehLE","wiggle":"_2pL6P"};